export default __webpack_public_path__ + "static/media/Frame 758532309.a40c1aa5.svg";